.page.not-found-page
  h1 Es gibt ein Problem :-(
  p Tut mir leid, aber <code>/#{path}</code> kann ich nicht für dich öffnen.
